import React, { useState } from 'react'

import { Box, Button, SearchField } from '@factorialco/deprecated-design-system'
import { ResultConceptItemTableRowFragment } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import EditColumnSidepanel from './EditColumnSidepanel/EditColumnSidepanel'

interface Props {
  onTableSearch?: (searchTerm: string) => void
  mappedResultConcepts: ResultConceptItemTableRowFragment['concept'][]
}

const Options = ({ onTableSearch, mappedResultConcepts }: Props) => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const [showEditColumnSidepanel, setShowEditColumnSidepanel] = useState(false)

  useEffect(() => {
    if (!onTableSearch) return

    onTableSearch(debouncedSearch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch])

  function handleOpenSidepanel() {
    setShowEditColumnSidepanel(true)
  }

  function handleCloseSidepanel() {
    setShowEditColumnSidepanel(false)
  }

  return (
    <Box
      width="full"
      alignItems="center"
      flexDirection="row"
      background="grey200"
      gap="s8"
      justifyContent="spaceBetween"
    >
      <Box width="full" alignItems="center" flexDirection="row" gap="s16">
        <Box flexGrow>
          <SearchField
            variant="big"
            autofocus
            search={search}
            onSearch={onSearch}
            placeholder={i18n.t('common.search')}
          />
        </Box>
        <Button type="secondary" onClick={handleOpenSidepanel}>
          {i18n.t('payroll_bundle.results_payments.results.summary.edit_columns')}
        </Button>
        <EditColumnSidepanel
          open={showEditColumnSidepanel}
          onClose={handleCloseSidepanel}
          mappedResultConcepts={mappedResultConcepts}
        />
      </Box>
    </Box>
  )
}

export default Options
